import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import cookie from "js-cookie";
import { DatePicker } from "react-advance-jalaali-datepicker";
import ExportJsonExcel from "js-export-excel";
import moment from "moment";
import categoryUserSitePublisherAction from "../../../store/actions/categoryUserSitePublisher";
import httpService from "../../../services/httpServices/httpServices";
import Pagination from "../../partials/content/Pagination";
import validateFormPermission from "../../../validtions/forms/category-user-site-publishers/add-categories-user-site-publishers";
import typeGroupSitePublisher from "./TypeGroupSitePublisher";
import messageCategoryUserSitePublishers from "../../../messages/category-user-site-publishers";
import helperSpinner from "../../../helpers/spinner";
import helpersNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import typeActionCategoryUserSitePublisher from "../../../store/actions/typeActionCategoryUserSitePublisher";
import actionCookie from "../../../helpers/action-cookie";
import SelectDropDown from "../../partials/content/SelectDropDown";
import ExportFileExcelButton from "./ExportFileExcelButton";
import PreviewPositionsGroupSitePublisher from "./PreviewPositionsGroupSitePublisher";

function AddGroupSitePublisher({
  categoryUser,
  dataSitePublisher,
  render,
  emptyPositions,
  setDates,
  startDate,
  endDate,
  nameCategory,
  resetDate,
  setTypeAction,
}) {
  const [message, setMessage] = useState();

  const [categoriesSitePublisher, setCategoriesSitePublisher] = useState([]);
  const [sitesPublisher, setSitesPublisher] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [siteNameSearchFilter, setSiteNameSearchFilter] = useState();
  const [countPage, setCountPage] = useState(1);
  const [categoryNameSearchFilter, setCategoryNameSearchFilter] = useState();
  const [isCheckPreviousSearchInput, setIsCheckPreviousSearchInput] =
    useState(false);
  const [
    editDateCategoryUserSitePublisher,
    setEditDateCategoryUserSitePublisher,
  ] = useState(false);

  const previousPageUrl = cookie.get(actionCookie.PREVIOUS_PAGE_URL);

  const checkPreviousPageUrlIsAllPageSitePublishers = () => {
    if (
      previousPageUrl.includes("/publishers/") &&
      previousPageUrl.includes("/all-page")
    ) {
      return true;
    }
    return false;
  };

  const [isShowWebSite, setIsShowWebSite] = useState(() => {
    if (!checkPreviousPageUrlIsAllPageSitePublishers()) {
      startDate = null;
      endDate = null;
    }
    if (startDate !== null && endDate !== null) {
      return true;
    }

    return false;
  });

  if (!startDate) {
    startDate = moment(helpersTime.getDateNow())
      .add(1, "days")
      .format("YYYY/M/D");
  }

  if (!endDate) {
    endDate = moment(helpersTime.getDateNow())
      .add(2, "days")
      .format("YYYY/M/D");
  }

  setTypeAction({
    type_action: typeActionCategoryUserSitePublisher.ADD,
  });

  const typeAdvertisePublisher = "banner";
  const history = useHistory();

  let messageTag;
  if (message) {
    messageTag = (
      <div key={Math.random()} className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    if (categoriesSitePublisher.length > 0) {
      return;
    }
    getCategoriesSitesPublisher();
  }, []);

  useEffect(() => {
    checkPreviousSearchInput();
    if (!checkPreviousPageUrlIsAllPageSitePublishers()) {
      resetDate();
      emptyPositions();
    }
  }, []);

  useEffect(() => {
    if (!isCheckPreviousSearchInput) {
      return;
    }
    getSitesPublisher();
  }, [
    currentPage,
    siteNameSearchFilter,
    categoryNameSearchFilter,
    isCheckPreviousSearchInput,
  ]);

  const checkPreviousSearchInput = () => {
    const previousSearchInputPage = cookie.get(
      actionCookie.GROUP_SITE_PUBLISHER_PAGE
    );
    const previousSiteNameSearch = cookie.get(
      actionCookie.GROUP_SITE_PUBLISHER_SITE_NAME_SEARCH
    );
    const previousCategoryNameSearchFilter = cookie.get(
      actionCookie.GROUP_SITE_PUBLISHER_CATEGORY_NAME_SEARCH_FILTER
    );

    if (previousSearchInputPage) {
      setCurrentPage(previousSearchInputPage);
    }

    if (previousSiteNameSearch != undefined) {
      setSiteNameSearchFilter(previousSiteNameSearch);
      setInputSearchSitePublisher(previousSiteNameSearch);
    }

    if (previousCategoryNameSearchFilter) {
      setCategoryNameSearchFilter(decodeURI(previousCategoryNameSearchFilter));
    }

    removeCookiePreviousSearchInput();
    setIsCheckPreviousSearchInput(true);
  };

  const removeCookiePreviousSearchInput = () => {
    cookie.remove(actionCookie.GROUP_SITE_PUBLISHER_PAGE);
    cookie.remove(actionCookie.GROUP_SITE_PUBLISHER_SITE_NAME_SEARCH);
    cookie.remove(
      actionCookie.GROUP_SITE_PUBLISHER_CATEGORY_NAME_SEARCH_FILTER
    );
  };

  const getCategoriesSitesPublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const categories = await sendRequestGetCategoryAllPublisher();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!categories) {
      return;
    }
    setCategoriesSitePublisher(categories);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (siteNameSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&site=${siteNameSearchFilter}`;
    }
    if (categoryNameSearchFilter) {
      if (categoryNameSearchFilter != "همه دسته ها") {
        searchFilterQuery = `${searchFilterQuery}&category=${categoryNameSearchFilter}`;
      }
    }

    return searchFilterQuery;
  };

  const getSitesPublisher = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const sitesPublisher = await sendRequestSitesPublisher(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!sitesPublisher) {
      return;
    }

    setSitesPublisher(sitesPublisher.data);
    setCountPage(sitesPublisher.total_page);
  };

  const setSearchInputOnCookie = () => {
    if (currentPage) {
      cookie.set(actionCookie.GROUP_SITE_PUBLISHER_PAGE, currentPage);
    }
    if (siteNameSearchFilter) {
      cookie.set(
        actionCookie.GROUP_SITE_PUBLISHER_SITE_NAME_SEARCH,
        siteNameSearchFilter
      );
    }
    if (categoryNameSearchFilter) {
      cookie.set(
        actionCookie.GROUP_SITE_PUBLISHER_CATEGORY_NAME_SEARCH_FILTER,
        encodeURIComponent(categoryNameSearchFilter)
      );
    }
  };

  const generateBodyTable = (sitesPublisher) => {
    return sitesPublisher.map((sitePublisher, index) => {
      return (
        <tr key={index}>
          <td>{helpersNumbers.toPersianNum(index + 1)}</td>
          <td>
            <a href={sitePublisher.url} target="_blank">
              {sitePublisher.url}
            </a>
          </td>
          <td>{sitePublisher.categories.join(" - ")}</td>
          <td>
            <div className="d-flex justify-content-around">
              <span>
                <i className="fa fa-mobile-alt"></i>
              </span>
              <span>
                <i className="fa fa-desktop"></i>
              </span>
            </div>
          </td>
          <td>
            <div>
              <span>
                <Link
                  onClick={setSearchInputOnCookie}
                  to={`/publishers/${sitePublisher.id}/all-page`}
                  className="btn btn-info"
                >
                  جایگاه های نمایش تبلیغات
                </Link>
              </span>
            </div>
          </td>
        </tr>
      );
    });
  };

  const generateTagSitesPublisher = () => {
    return (
      <>
        <div className="col-12 pb-3">
          <div className="table-responsive pt-3">
            <table className="table table-hilite tbl-td-white-space table-hover">
              <thead>
                <tr>
                  <td>#</td>
                  <td>نمایش دهنده</td>
                  <td>دسته بندی موضوع</td>
                  <td>قابل نمایش در</td>
                  <td>نمایش صفحات</td>
                </tr>
              </thead>
              <tbody>
                {sitesPublisher.length > 0 ? (
                  generateBodyTable(sitesPublisher)
                ) : (
                  <tr>
                    <td
                      colspan="5"
                      className="text-center"
                      style={{ borderBottomRightRadius: "25px" }}
                    >
                      هیچ سایتی با این مشخصات موجود نیست.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
          {countPage > 1 && generatePagination()}
        </div>
      </>
    );
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generatePagination = () => {
    return (
      <Pagination
        countPage={countPage}
        currentPage={currentPage}
        paginationItemOnClickHandler={paginationItemOnClickHandler}
      />
    );
  };

  const sendRequestSitesPublisher = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let sitePublishers;
    try {
      sitePublishers = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/site-publishers?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      return false;
    }
    return sitePublishers.data.data;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const sendRequestGetCategoryAllPublisher = async () => {
    const headersRequest = getHeaderForRequest();
    let categoryAllPublisher;
    try {
      categoryAllPublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/category-site-publishers",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return categoryAllPublisher.data.data;
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const dataForm = getDataForm();
    const result = validateFormPermission(dataForm);
 
    if (result != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validateFormPermission(dataForm),
        class_icon: "fa fa-exclamation-triangle",
      });
      helperSpinner.scrollForSeeMessage(".card");
      return;
    }
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (await sendRequestAddCategoryUserSitePublisher(dataForm)) {
      emptyPositions();

      if (
        window.location.pathname ===
        "/campaigns/banner/simple/add-group-site-publisher"
      ) {
        history.push("/campaigns/banner/simple/add");
        return;
      }
      history.push("/publishers/all");
      return;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const sendRequestAddCategoryUserSitePublisher = async (dataForm) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/category-user-site-publishers",
        dataForm,
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      helperSpinner.scrollForSeeMessage(".card");
      return false;
    }

    return true;
  };

  const getDataForm = () => {
    const typeGroupPublisher = typeGroupSitePublisher.getTypeGroupPublisher(
      typeAdvertisePublisher
    );
    startDate = helpersTime.convertJalaliToGregorian(startDate);
    endDate = helpersTime.convertJalaliToGregorian(endDate);
    return {
      name: document.getElementById("name").value.trim(),
      type_id: "" + typeGroupPublisher,
      amount: getPriceCategoryUserSitePublisher(dataSitePublisher) + "",
      start_date: startDate,
      end_date: endDate,
      sites: dataSitePublisher,
    };
  };

  const generateEachSitePublisherArrayReportExportExcel = (
    sitePublisherDataParam
  ) => {
    let sitePublisherUrl = sitePublisherDataParam.url;

    let dataEachSitePublisherExcelFile = [
      {
        one: sitePublisherUrl,
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(
            getPriceSitePublisher(sitePublisherDataParam)
          )
        ),
      },
    ];

    for (const key in sitePublisherDataParam) {
      if (key === "url") {
        continue;
      }

      const item = sitePublisherDataParam[key];
      dataEachSitePublisherExcelFile = [
        ...dataEachSitePublisherExcelFile,
        ...generatePageDataReportExportExcel(item),
      ];
    }

    return dataEachSitePublisherExcelFile;
  };

  const setInputSearchSitePublisher = (value = "") => {
    document.querySelector("#site").value = value;
  };

  const showSelectCategorySitePublisher = () => {
    let categoriesSitesPublishersForDropDown = categoriesSitePublisher.filter(
      (category) => category.name != categoryUser
    );

    categoriesSitesPublishersForDropDown =
      categoriesSitesPublishersForDropDown.map((category) => {
        return { value: category.id, label: category.name };
      });

    categoriesSitesPublishersForDropDown = [
      { value: 0, label: "همه دسته ها" },
      ...categoriesSitesPublishersForDropDown,
    ];

    let itemSelected;
    if (categoryNameSearchFilter) {
      itemSelected = categoriesSitesPublishersForDropDown.filter(
        (category) => category.label == categoryNameSearchFilter
      );

      if (itemSelected.length > 0) {
        itemSelected = {
          label: itemSelected[0].label,
          value: itemSelected[0].value,
        };
      }
    }

    return (
      <SelectDropDown
        data={categoriesSitesPublishersForDropDown}
        itemSelected={itemSelected}
        setItemHandler={(newItemSelected) => {
          setCategoryNameSearchFilter(newItemSelected.label);
          setCurrentPage(1);
          setSiteNameSearchFilter();
          setInputSearchSitePublisher();
        }}
      />
    );
  };

  const generatePageDataReportExportExcel = (pageDataReport) => {
    return [
      {
        one: pageDataReport.title,
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(pageDataReport.price)
        ),
      },
      { ...pageDataReport.positions },
      { one: "", two: "" },
    ];
  };

  const getPriceSitePublisher = (priceSitePublisher) => {
    let pricePage = 0;
    const newSitePublisherData = { ...priceSitePublisher };
    for (const key in newSitePublisherData) {
      if (key === "url") {
        continue;
      }
      pricePage = pricePage + newSitePublisherData[key].price;
    }
    return pricePage;
  };

  const getPriceCategoryUserSitePublisher = (sitePublisherData) => {
    let priceCategoryUserSitePublisher = 0;
    for (let key in sitePublisherData) {
      priceCategoryUserSitePublisher += getPriceSitePublisher(
        sitePublisherData[key]
      );
    }
    return priceCategoryUserSitePublisher;
  };

  const checkStartDateEntered = (startDateEntered) => {
    startDateEntered = helpersTime.convertJalaliToGregorian(startDateEntered);
    if (moment(startDateEntered).diff(startDate, "d") < 0) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.START_DATE_IS_PAST_FROM_CURRENT_DATE,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    let currentDate = moment(new Date().toISOString().split("T")[0]);
    const differentDates = moment(startDateEntered).diff(currentDate, "days");
    let maxCountDaysCategoryUserSitePublisherForStartDate =
      parseInt(
        process.env.REACT_APP_MAX_COUNT_DAYS_CATEGORY_USER_SITE_PUBLISHER
      ) - 1;
    if (differentDates > maxCountDaysCategoryUserSitePublisherForStartDate) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.START_DATE_IS_TOO_MUCH,
        class_icon: "fa fa-exclamation-triangle",
      });

      return false;
    }

    return true;
  };

  const checkEndDateEntered = (endDateEntered, startDateEntered) => {
    endDateEntered = helpersTime.convertJalaliToGregorian(endDateEntered);

    if (moment(endDateEntered).diff(endDate, "d") < 0) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.END_DATE_IS_PAST_FROM_START_DATE,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    if (
      moment(endDateEntered).diff(
        moment(helpersTime.convertJalaliToGregorian(startDateEntered)),
        "d"
      ) < 0
    ) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.END_DATE_IS_PAST_FROM_START_DATE,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    let currentDate = moment(new Date().toISOString().split("T")[0]);
    const differentDates = moment(endDateEntered).diff(currentDate, "days");
    if (
      differentDates >
      parseInt(
        process.env.REACT_APP_MAX_COUNT_DAYS_CATEGORY_USER_SITE_PUBLISHER
      )
    ) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.END_DATE_IS_TOO_MUCH,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    return true;
  };

  const showWebSites = () => {
    const startDateEntered = document.querySelector(".start-date input").value;
    const endDateEntered = document.querySelector(".end-date input").value;
    const nameCategory = document.querySelector("#name").value.trim();

    if (!nameCategory) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.NAME_DOSE_NOT_EXIST,
        class_icon: "fa fa-exclamation-triangle",
      });
      helperSpinner.scrollForSeeMessage(".card");
      return;
    }

    if (editDateCategoryUserSitePublisher) {
      startDate = helpersTime.convertJalaliToGregorian(startDate);
      endDate = helpersTime.convertJalaliToGregorian(endDate);
    }

    if (!checkStartDateEntered(startDateEntered)) {
      helperSpinner.scrollForSeeMessage(".card");
      return;
    }
    if (!checkEndDateEntered(endDateEntered, startDateEntered)) {
      helperSpinner.scrollForSeeMessage(".card");
      return;
    }

    setDates({
      name_category: nameCategory,
      start_date: startDateEntered,
      end_date: endDateEntered,
    });
    setIsShowWebSite(true);
    if (editDateCategoryUserSitePublisher) {
      setEditDateCategoryUserSitePublisher(false);
      emptyPositions();
    }
  };

  const generateTableEditDateCategoryUserSitePublisher = () => {
    return (
      <div className="col-12">
        <div className="table-responsive pt-3">
          <table className="table table-hilite">
            <thead>
              <tr>
                <td className="text-nowrap">
                  ارزش یک شبانه روز گروه نمایش دهنده{" "}
                </td>
                <td>تاریخ شروع </td>
                <td>تاریخ پایان </td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span className="px-2 letter-spacing-finance-number">
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(
                        getPriceCategoryUserSitePublisher(dataSitePublisher)
                      )
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
                <td>
                  <span className="number-finance">
                    {helpersNumbers.toPersianNum(startDate)}
                  </span>
                </td>
                <td>
                  <span className="number-finance">
                    {helpersNumbers.toPersianNum(endDate)}
                  </span>
                </td>
                <td>
                  <span>
                    <span
                      className="btn btn-danger"
                      onClick={() => {
                        setEditDateCategoryUserSitePublisher(false);
                        setIsShowWebSite(true);
                      }}
                    >
                      انصراف از ویرایش تاریخ شروع و پایان و نمایش سایت ها{" "}
                    </span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <>
      {messageTag}
      <div className="alert alert-warning">
        <p className="text-justify">
          <i className="fa fa-info pl-2"></i>
          توجه داشته باشید :{" "}
        </p>
        <ul className="pr-3">
          <li>
            <p className="text-justify">
              ساعت تاریخ شروع از ۰۰:۰۰ و ساعت تاریخ پایان از ۲۳:۵۹
            </p>
          </li>
          <li>
            <p className="text-justify">
              {" "}
              به طور مثال : تاریخ شروع ۰۰:۰۰ ۱۴۰۰/۴/۲ و تاریخ پایان ۲۳:۵۹
              ۱۴۰۰/۴/۲۰
            </p>
          </li>
          <li>
            <p className="text-justify">
              تاریخ شروع گروه بنری سایت های نمایش دهنده شما باید در بازه یک روز
              بعد از تاریخ جاری تا ۸۹ روز بعد
            </p>
          </li>
          <li>
            <p className="text-justify">
              تاریخ پایان گروه بنری سایت های نمایش دهنده شما باید در بازه دو روز
              بعد از تاریخ جاری تا ۹۰ روز بعد باشد
            </p>
          </li>
          <li>
            <p className="text-justify">به طور مثال : تاریخ جاری ۱۴۰۰/۷/۱</p>
          </li>
          <li>
            <p className="text-justify">
              بازه مجاز برای تاریخ شروع ۱۴۰۰/۷/۲ - ۱۴۰۰/۹/۲۹- دو روز ۷/۲ و ۹/۲۹
              جزیی از این بازه هستن که ۸۹ روز میشود
            </p>
          </li>
          <li>
            <p className="text-justify">
              بازه مجاز برای تاریخ پایان ۱۴۰۰/۷/۳ - ۱۴۰۰/۱۰/۲- دو روز ۷/۳ و ۱۰/۲
              جزیی از این بازه هستن که ۹۰ روز میشود
            </p>
          </li>
          <li>
            <p className="text-justify">
              توجه داشته باشید که ۶ ماه ابتدا سال ۳۱ روزه و اسفند ماه ۲۹ روز
              است.
            </p>
          </li>
          <li>
            <p className="text-justify">
              قبل از اضافه کردن گروه , حتما به وسیله دکمه سبز رنگ پایین سمت چپ
              یک گزارش از سایت ها , صفحات , جایگاه های تبلیغاتی انتخاب شده
              بگیرید.
            </p>
          </li>
        </ul>
      </div>

      <form onSubmit={sendForm}>
        <div className="form-group">
          <label>نام گروه</label>
          <input
            type="text"
            className="form-control"
            placeholder="نام گروه"
            id="name"
            defaultValue={nameCategory != null ? nameCategory : ""}
            required
          />
        </div>

        <div className="form-group">
          <div className="container-fluid p-0">
            <div className="row align-items-end">
              {isShowWebSite ? (
                <div className="col-12">
                  <div className="table-responsive pt-3">
                    <table className="table table-hilite">
                      <thead>
                        <tr>
                          <td className="text-nowrap">
                            ارزش یک شبانه روز گروه نمایش دهنده{" "}
                          </td>
                          <td>تاریخ شروع </td>
                          <td>تاریخ پایان </td>
                          <td>عملیات</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <span className="px-2 letter-spacing-finance-number">
                              {helpersNumbers.toPersianNum(
                                helpersNumbers.toFormatFinanceNumber(
                                  getPriceCategoryUserSitePublisher(
                                    dataSitePublisher
                                  )
                                )
                              )}
                            </span>
                            <span className="pr-2">تومان</span>
                          </td>
                          <td>
                            <span className="number-finance">
                              {helpersNumbers.toPersianNum(startDate)}
                            </span>
                          </td>
                          <td>
                            <span className="number-finance">
                              {helpersNumbers.toPersianNum(endDate)}
                            </span>
                          </td>
                          <td>
                            {editDateCategoryUserSitePublisher ? (
                              <span>
                                <span
                                  className="btn btn-danger"
                                  onClick={() => {
                                    setEditDateCategoryUserSitePublisher(false);
                                    setIsShowWebSite(true);
                                  }}
                                >
                                  انصراف از ویرایش تاریخ شروع و پایان و نمایش
                                  سایت ها{" "}
                                </span>
                              </span>
                            ) : (
                              <span>
                                <span
                                  className="btn btn-success"
                                  onClick={() => {
                                    setEditDateCategoryUserSitePublisher(true);
                                    setIsShowWebSite(false);
                                  }}
                                >
                                  ویرایش تاریخ شروع و تاریخ پایان
                                </span>
                              </span>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <>
                  {editDateCategoryUserSitePublisher && (
                    <div className="alert alert-warning w-100">
                      <p className="text-justify">
                        <i className="fa fa-info pl-2"></i>
                        توجه داشته باشید :{" "}
                      </p>
                      <ul className="pr-3">
                        <li>
                          <p className="text-justify">
                            در صورت ویرایش تاریخ شروع و پایان جایگاه های از قبل
                            انتخاب شده حذف میشوند شما دوباره باید جایگاه ها را
                            انتخاب کنید.
                          </p>
                        </li>
                      </ul>
                    </div>
                  )}

                  <div className="col-12 col-md-4 pb-3">
                    <div>
                      <div>
                        <label>تاریخ شروع</label>
                      </div>
                      <div className="custom-data-picker start-date">
                        <DatePicker
                          placeholder="انتخاب تاریخ"
                          format="jYYYY/jMM/jDD"
                          preSelected={
                            editDateCategoryUserSitePublisher
                              ? startDate
                              : helpersTime.convertGregorianToJalali(startDate)
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-4 pb-3">
                    <div>
                      <div>
                        <label>تاریخ پایان</label>
                      </div>
                      <div className="custom-data-picker end-date">
                        <DatePicker
                          placeholder="انتخاب تاریخ"
                          format="jYYYY/jMM/jDD"
                          preSelected={
                            editDateCategoryUserSitePublisher
                              ? endDate
                              : helpersTime.convertGregorianToJalali(endDate)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div className="col-12 col-md-4 pb-3">
                {isShowWebSite ? (
                  <></>
                ) : (
                  <button
                    className="btn btn-success w-100"
                    onClick={(e) => {
                      e.preventDefault();
                      showWebSites();
                    }}
                    disabled={isShowWebSite ? "disabled" : ""}
                  >
                    اعمال تاریخ و نمایش سایت ها
                  </button>
                )}
              </div>
            </div>
          </div>

          {editDateCategoryUserSitePublisher &&
            generateTableEditDateCategoryUserSitePublisher()}

          <div
            className={`container-fluid p-0 ${isShowWebSite ? "" : "d-none"} `}
          >
            <div className="row">
              <div className="col-12 col-md-6">
                <div>
                  <label>جستجو آدرس سایت</label>
                </div>
                <div>
                  <input
                    className="form-control"
                    id="site"
                    type="text"
                    onKeyUp={(e) => {
                      setSiteNameSearchFilter(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div>
                  <div>
                    <label>دسته بندی نمایش دهنده های مرتبط (برای شما)</label>
                  </div>
                  <div>{showSelectCategorySitePublisher()}</div>
                </div>
              </div>

              {sitesPublisher.length == 0 &&
              siteNameSearchFilter == null &&
              categoryNameSearchFilter == null ? (
                <></>
              ) : (
                generateTagSitesPublisher()
              )}
            </div>
            <div className="col-12">
              <div className="form-group">
                <button type="submit" className="btn btn-success">
                  اضافه کردن
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <ExportFileExcelButton />
      <PreviewPositionsGroupSitePublisher />
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    categoryUser: state.main.categoryUser,
    dataSitePublisher: state.categoryUserSitePublisher.data_site_publisher,
    render: state.categoryUserSitePublisher.render,
    nameCategory: state.categoryUserSitePublisher.name_category,
    startDate: state.categoryUserSitePublisher.start_date,
    endDate: state.categoryUserSitePublisher.end_date,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    emptyPositions: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.EMPTY_POSITION,
        payload: action,
      });
    },
    setDates: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.SET_DATE,
        payload: action,
      });
    },
    setTypeAction: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.SET_TYPE_ACTION,
        payload: action,
      });
    },
    resetDate: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.RESET_DATE,
        payload: action,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddGroupSitePublisher);
